import React from 'react';
import styles from './DrMaxReserveMedicamentsListItem.module.scss';
import Icon from '../../../BaseModule/Components/Layout/Icon/Icon';
import useTranslation from '../../../../Hooks/useTranslation';
import InStock from '../InStock/InStock';

interface Props {
	item: Medicament;
}

export interface Medicament {
	name: string;
	formattedApproximatePrice: string;
	inStock: boolean;
}

const DrMaxReserveMedicamentsListItem: React.FC<Props> = ({ item }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>{item.name}</div>
			<div className={styles.content}>
				{item?.inStock !== undefined && <InStock inStock={item.inStock} />}
			</div>
		</div>
	);
};

export default DrMaxReserveMedicamentsListItem;
